import { render, staticRenderFns } from "./TermsAndConditionsAccept.vue?vue&type=template&id=6cd58abd"
import script from "./TermsAndConditionsAccept.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsAccept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports